<template>
  <v-img
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template
      v-for="(_, name) in $slots"
      #[name]
    >
      <slot :name="name" />
    </template>
  </v-img>
</template>

<script>
export default {
  name: "EkitabuImage",
  inheritAttrs: false,
};
</script>
